import { Account, LoggedUser } from '../../session/session-decode';
import { isIntegrator } from '../../session/user-type';

/** `tipoLicenca`, em maiúsculas, contém "ACCESS"; `false` quando `tipoLicenca` está ausente. */
export function isAccessAccount(account: Account): boolean {
  return !!account.tipoLicenca && account.tipoLicenca.toUpperCase().includes('ACCESS');
}

/** Remove as contas ACCESS; usada apenas para a lista do integrador. */
export function excludeAccess(accounts: readonly Account[]): Account[] {
  return accounts.filter((account) => !isAccessAccount(account));
}

/** Substring case-insensitive sobre `nomeConta`; filtro vazio devolve a lista inteira. */
export function filterAccounts(accounts: readonly Account[], searchTerm: string): Account[] {
  if (!searchTerm) {
    return [...accounts];
  }

  const searchTermUpper = searchTerm.toUpperCase();
  return accounts.filter((account) => account.nomeConta.toUpperCase().includes(searchTermUpper));
}

/** Ordena ascendente por `nomeConta`; devolve uma cópia, não muta a entrada. */
export function sortAccountsByName(accounts: readonly Account[]): Account[] {
  return [...accounts].sort((a, b) =>
    a.nomeConta < b.nomeConta ? -1 : a.nomeConta > b.nomeConta ? 1 : 0,
  );
}

/**
 * Origem por tipo de usuário: integrador usa `integratorAccounts` (ou `[]` quando
 * `null`) sem contas ACCESS; caso contrário usa `user.contas` sem exclusão. Em
 * ambos os casos, o resultado é filtrado por `searchTerm` e ordenado por `nomeConta`.
 */
export function buildAccountList(
  user: LoggedUser | null,
  integratorAccounts: readonly Account[] | null,
  searchTerm: string,
): Account[] {
  const source = isIntegrator(user)
    ? excludeAccess(integratorAccounts ?? [])
    : (user?.contas ?? []);

  return sortAccountsByName(filterAccounts(source, searchTerm));
}
